import './index.css';

import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import { ToastContainer } from './components/common/Toast';
import InsuranceTypeProvider from './context/InsuranceTypeProvider';
import i18n from './i18n/config';
import { useAuthStore } from './lib/auth/auth-store';
import { router } from './lib/router/router';

useAuthStore.getState().initializeAuth();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <InsuranceTypeProvider>
        <RouterProvider router={router} />
        <ToastContainer />
      </InsuranceTypeProvider>
    </I18nextProvider>
  </StrictMode>
);
